import { QuestionAndAnswerModel } from "./questionAndAnswer.model";

export class QuestionProcessModel {
    public questionsAndAnswers: Array<QuestionAndAnswerModel> = [];
    public additionalExplanationIds: number[] = [];

}

